<template>
  <div class="card_slide_up">

    <transition name="modal_fade">
      <Modal v-if="showComponents" @click.native="closeModalSlideUp(), $store.commit('navBarMinimised', false)"></Modal>
    </transition>

    <transition name="card_slide">
      <Card v-if="showComponents" :class="layout">
        <slot></slot>
      </Card>
    </transition>

  </div>
</template>

<script>
import Modal from '@/components/Modal.vue'
import Card from '@/components/Card.vue'

export default {
  props: [
    'showComponents',
    'layout',
  ],
  components: {
    Card,
    Modal,
  },
  data: function () {
    return {
    }
  },
  methods: {
    closeModalSlideUp() {
      this.$emit('updateStatus');
    }
  },
  computed: {
  }
}
</script>


<style scoped>
.card_slide_up {
  z-index: 1200
}

/*MODAL TRANSITIONS*/
.modal_fade-enter-active, .modal_fade-leave-active {
  transition: 0.3s opacity ease;
}
.modal_fade-enter, .modal_fade-leave-to {
  opacity: 0;
}
.card_slide-enter-active, .card_slide-leave-active {
  transition: 0.3s transform ease;
}
.card_slide-enter, .card_slide-leave-to {
  transform: translateY(100%);
}
</style>
